<template>
  <div class="equ-num">
    <custom-plane
      title="电梯"
      :iconImg="require('@/assets/compImg/EquipmentIcon/lifts.png')"
    >
      <div class="equ_data">
        <div class="numb">
          <div class="numb_text">正常数量</div>
          <div class="numb_value normal">
            {{ normalNum }}
          </div>
        </div>
        <div class="numb">
          <div class="numb_text">待机数量</div>
          <div class="numb_value">{{ stanyNum }}</div>
        </div>
        <div class="numb">
          <div class="numb_text">故障数量</div>
          <div class="numb_value abnormal">
            {{ errorNum }}
          </div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  props: {
    evaData: Array,
  },
  computed: {
    errorNum() {
      return this.setNum("fault");
    },
    stanyNum() {
      return this.setNum("standby");
    },
    normalNum() {
      return this.setNum("normal");
    },
  },
  methods: {
    setNum(status) {
      if (!this.evaData) {
        return "-";
      } else if (!this.evaData[4]) {
        return "";
      } else {
        return this.evaData[4][status];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.equ-num {
  width: 100%;
  height: 198px;

  .equ_data {
    width: 100%;
    height: 92px;
    margin-top: 30px;
    padding: 0 34px;
    display: flex;
    justify-content: space-between;
    text-align: center;

    .numb {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .numb_text {
        font-size: 18px;
        width: 88px;
        height: 27px;
      }

      .numb_value {
        font-family: "dina";
        font-size: 48px;
        width: 88px;
        height: 55px;
      }

      .normal {
        color: #2d82ff;
      }

      .abnormal {
        color: #f1802f;
      }
    }
  }
}
</style>
